import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/utilidades/';

export default {
  async detalleEscaneoFactura(object) {
    const response = await axios.post(API_URL + "detalle-escaneo-factura", object, { headers: authHeader() }); console.log('Response',response.data);
    if (response.data) {
      return response.data;
    }
  },
  async uploadEscaneoFactura(formData, onProgress, signal) {
    const response = await axios.post(API_URL + "upload-escaneo-factura", formData, {
      headers: authHeader(),
      onUploadProgress: onProgress,
      signal,
    });
    if (response.data) {
      return response.data;
    }
  },
  async validaDatoFactura(object) {
    const response = await axios.post(API_URL + "valida-dato-factura", object, {headers: authHeader()});
    if (response.data) {
      return response.data;
    }
  },
  async finalizaEscaneoFactura(object) {
    const response = await axios.post(API_URL + "finaliza-escaneo-factura", object, {headers: authHeader()});
    if (response.data) {
      return response.data;
    }
  },
  async borraEscaneoFactura(object) {
    const response = await axios.post(API_URL + "borra-escaneo-factura", object, {headers: authHeader()});
    if (response.data) {
      return response.data;
    }
  }
};
